import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CharactersPage from "../pages/characters/page";
import CharacterDetail from "../pages/character/detail/page";
import SeiyuuPage from "../pages/seiyuu/page";
import WorksPage from "../pages/works/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/characters",
    element: <CharactersPage />,
  },
  {
    path: "/character/:id",
    element: <CharacterDetail />,
  },
  {
    path: "/seiyuu",
    element: <SeiyuuPage />,
  },
  {
    path: "/works",
    element: <WorksPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;